const urls = {
    home: '/',
    userCallback: '/user/callback',
    login: '/login'
}

export default urls